module.exports = __webpack_public_path__ + "static/img/10.160bd53.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/sp/10.png
// module id = TY8N
// module chunks = 0